// WIP

import { monitDispoziceMistnosti } from '../../common/monitTypes'

export const UNIT_DISPOSITION_OPTIONS = Object.entries(
  monitDispoziceMistnosti
).map(([value, label]) => ({ value: Number(value), label }))

// Pozn.: Nezasahujeme do prislusenstvi_fl_values (globální monit typy),
// protože zde potřebujeme rozšířený / specifický set pro kalkulačku.
export const UNIT_UTILITY_DICTIONARY: Record<number, string> = {
  0x00000008: 'Sklep',
  0x00000010: 'Garážové stání', // původně v monitTypes jako "garáž" – zde specifikujeme jemnější význam
  0x5000: 'Parkovací stání',
  0x6000: 'Balkón / lodžie',
  0x00000004: 'Terasa',
  0x0200: 'Výtah',
  0x9000: 'Zahrada',
  0xf003: 'Bezbariérový přístup',
  0xf004: 'Novostavba',
}

export const UNIT_UTILITY_OPTIONS = Object.entries(UNIT_UTILITY_DICTIONARY).map(
  ([value, label]) => ({ value: Number(value), label })
)

export const getUnitDispositionText = (
  value?: keyof typeof monitDispoziceMistnosti | null
): string => {
  if (value == null) return ''
  return monitDispoziceMistnosti[value] ?? String(value)
}

export const getUnitUtilitiesText = (
  values?: (number | undefined | null)[]
): string => {
  if (!values || !values.length) return ''
  return values
    .filter(value => value != null)
    .map(value => UNIT_UTILITY_DICTIONARY[value as number] ?? String(value))
    .join(', ')
}

export const BUILDING_UTILITY_DICTIONARY: Record<number, string> = {
  0x00400000: 'bazén',
  0x0020: 'Balkón, lodžie, terasa',
  0x00000010: 'garáž',
}

export const BUILDING_UTILITY_OPTIONS = Object.entries(
  BUILDING_UTILITY_DICTIONARY
).map(([value, label]) => ({ value: Number(value), label }))

export const getBuildingUtilitiesText = (
  values?: (number | undefined | null)[]
): string => {
  if (!values || !values.length) return ''
  return values
    .filter(value => value != null)
    .map(value => BUILDING_UTILITY_DICTIONARY[value as number] ?? String(value))
    .join(', ')
}
